module.exports = "/assets/data/39ef57d4efa57899179976a4828275cb-BA21.data.json";